import dayjs from "dayjs";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usePatientById } from "../../../api/member-management/use-patient-detail";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import Button from "../../../components/ui/Button/Button";
import FieldBox from "../../../utils/Form/ui/FieldBox";
import { PatientHospitalTable } from "./patient-hospital-table";

const formatDateTime = (value) => {
  if (!value) return "-";
  return dayjs(value).format("YYYY-MM-DD HH:mm");
};

const PatientDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = usePatientById(id);
  const patientData = data?.data;
  const handleBack = () => {
    navigate("/patient");
  };

  return (
    <div>
      <TitlePage title="회원관리 > 회원상세" />
      <div className="flex mt-2 gap-8">
        <div className="w-[40%]">
          <h2 className="text-[16px] mb-4 font-bold">환자회원 정보</h2>
          <FieldBox unSplittedWidth="w-32 flex-none" label="환자명">
            {patientData?.name || "-"}
          </FieldBox>
          <FieldBox unSplittedWidth="w-32 flex-none" label="휴대전화 번호">
            {patientData?.contact || "-"}
          </FieldBox>
          <FieldBox unSplittedWidth="w-32 flex-none" label="주민등록번호">
            {patientData?.citizenNo || "-"}
          </FieldBox>
          <FieldBox unSplittedWidth="w-32 flex-none" label="주소">
            {patientData?.address || "-"}
          </FieldBox>
          <FieldBox unSplittedWidth="w-32 flex-none" label="가입일시">
            {formatDateTime(patientData?.createdAt)}
          </FieldBox>
          <FieldBox unSplittedWidth="w-32 flex-none" label="마지막 접속일시">
            {formatDateTime(patientData?.lastLoginAt)}
          </FieldBox>
          <FieldBox unSplittedWidth="w-32 flex-none" label="성별" isLast>
            {patientData?.gender === "F"
              ? "여성"
              : patientData?.gender === "M"
                ? "남성"
                : "-"}
          </FieldBox>
          <Button
            onClick={handleBack}
            text="목록으로"
            className="mt-4"
            width="w-20"
          />
        </div>
        <div className="w-[60%]">
          <h2 className="text-[16px] mb-4 font-bold">병원 목록</h2>
          <PatientHospitalTable id={id} />
        </div>
      </div>
    </div>
  );
};

export default PatientDetailPage;
